    const radForms = document.querySelectorAll('.rad-state-form');

    radForms.forEach(function(form) {
        form.addEventListener('submit', function(e) {
            e.preventDefault();

            const $thisForm = this;

            const cardRADs__container       = document.querySelector('.cardRADs__container');

            const cardRADs__firstname       = document.querySelector('.cardRADs__firstname');
            const cardRADs__lastname        = document.querySelector('.cardRADs__lastname');
            const cardRADs__phonenumber     = document.querySelector('.cardRADs__phonenumber');
            const cardRADs__email           = document.querySelector('.cardRADs__email');
            const cardRADs__error           = document.querySelector('.cardRADs__error');

            // Get the state selection dropdown value
            const stateInput = $thisForm.querySelector('.user_state_input');
            let rpa_user_state = stateInput ? stateInput.value : false;

            // Validate selection
            if (!rpa_user_state || rpa_user_state === "") {
                if (cardRADs__error) {
                    cardRADs__error.innerHTML = '<p>Please Select a State or Territory</p>';
                }
                return;
            }

            // console.log('Submitting State:', rpa_user_state);

            // Get result container (dynamic ID or fallback)
            const resultContainerId = $thisForm.getAttribute('data-result-container-id');
            let targetContainer = resultContainerId ? 
                document.getElementById(resultContainerId) : null;
            
            // Fallback for legacy single-instance support
            if (!targetContainer) {
                targetContainer = $thisForm.querySelector('#readRADs.contactCards');
            }

            const resultSingleContainer = document.querySelector('.readRADs.contactCards');

            // UI Feedback: Disable submit button during request
            const submitBtn = $thisForm.querySelector('button[type="submit"]') || 
                             $thisForm.querySelector('input[type="submit"]');
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.dataset.originalText = submitBtn.value || submitBtn.textContent;
                submitBtn.textContent = 'Searching...';
            }

            // Fetch API implementation (Vanilla JS replacement for jQuery $.post)
            fetch(wprpa_ajax_obj.ajax_url, {
                method: 'POST',
                body: new URLSearchParams({
                    action: 'readRADs',
                    nonce: wprpa_ajax_obj.nonce,
                    rpa_user_state: rpa_user_state
                }),
                headers: {
                    'X-Requested-With': 'XMLHttpRequest' // Required by WordPress AJAX system
                }
            })
            .then(response => response.json())
            .then(data => {
                if (targetContainer) {
                    cardRADs__container.style.display = 'block'

                    cardRADs__firstname.innerHTML      = data['data']['firstname'];
                    cardRADs__lastname.innerHTML       = data['data']['lastname'];
                    cardRADs__phonenumber.innerHTML    = data['data']['phonenumber'];
                    cardRADs__email.innerHTML          = data['data']['email'];


                    // console.log('State Results Loaded:', data);
                    
                    // Optional: Trigger custom event for other scripts to react
                    // const customEvent = new CustomEvent('radResultsLoaded', { detail: data });
                    // document.dispatchEvent(customEvent);
                } else if (resultSingleContainer) {
                    resultSingleContainer.innerHTML = data['data']['htmlRADs'];
                } else {
                    console.error('No target container found for RAD results.');
                }
            })
            .catch(error => {
                console.error('Error fetching RAD results:', error);
                if (cardRADs__error) {
                    cardRADs__error.innerHTML = '<p class="error-msg">Error loading results. Please try again later.</p>';
                }
            })
            .finally(() => {
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = submitBtn.dataset.originalText || 'Search';
                }
            });
        });
    });